import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function ShopTitle() {
  return <section data-section-id="223613" id="shop-title" className="relative bg-accent text-foreground py-16 md:py-24 border-b border-border overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05] mix-blend-multiply pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/cup_texture_overlay.png')] bg-repeat" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center text-center space-y-8">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-secondary tracking-tighter max-w-3xl">
            Unser Sortiment
          </h1>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 w-full">
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Startseite</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="text-secondary font-medium">Shop</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>

            <div className="hidden sm:block w-px h-4 bg-border" aria-hidden="true" />

            <span className="text-sm font-default font-semibold text-muted-foreground uppercase tracking-widest">
              6 Produkte verfügbar
            </span>
          </div>
        </div>
      </div>
    </section>;
}